import { render, staticRenderFns } from "./EnergeticChart.vue?vue&type=template&id=a8cca7d4&"
import script from "./EnergeticChart.vue?vue&type=script&lang=ts&"
export * from "./EnergeticChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports